export default "__VITE_ASSET__CduR94Ke__"